<template>
  <div>
    <div class="header">
      <el-image class="logo" :src="logo" mode="widthfix"></el-image>
      <!-- <el-image
        class="logo logo-white"
        :src="logoWhite"
        mode="heightFix"
      ></el-image> -->
      <div class="flex header-content">
        <div class="header-title">
          {{
            language === "cn"
              ? "参展商自助服务系统"
              : "Exhibitor Self-Service System"
          }}
        </div>
        <div class="cz flex" style="align-items: center">
          <div class="headertips">
            <span class="wcz"></span>
            <span>{{ language === "cn" ? "未操作" : "Not Started" }}</span>
          </div>
          <div class="headertips">
            <span class="jxz"></span>
            <span>{{ language === "cn" ? "进行中" : "In Progress" }}</span>
          </div>
          <div class="headertips">
            <span class="wtg"></span>
            <span>{{ language === "cn" ? "未通过" : "Rejected" }}</span>
          </div>
          <div class="headertips">
            <span class="ytg"></span>
            <span>{{ language === "cn" ? "已跳过" : "Skipped" }}</span>
          </div>
          <div class="headertips">
            <span class="ywc"></span>
            <span>{{ language === "cn" ? "已完成" : "Completed" }}</span>
          </div>
        </div>
      </div>
      <div class="language">
        <span
          @click="handleChooseLanguage('cn')"
          :class="language === 'cn' ? 'active' : ''"
          >中</span
        >
        <p></p>
        <span
          @click="handleChooseLanguage('en')"
          :class="language === 'en' ? 'active' : ''"
          >EN</span
        >
      </div>
      <div class="right">
        <!-- <div @click="tapdiscussion" class="cypx" v-if="menu_switch=='NHNE'||menu_switch=='ALL'">未来营养超市活动报名</div> -->
        <div class="username">
          {{ language === "cn" ? "登录名:" : "Account: "
          }}{{ userInfor.username }}
        </div>
        <div class="border">
          {{ language === "cn" ? "公司:" : "Company: " }}{{ userInfor.title }}
        </div>
        <div class="username">
          <el-popover
            placement="bottom"
            width="100"
            trigger="hover"
            style="width: 50px !important"
          >
            <p @click="openResetDialog">修改密码</p>
            <div slot="reference">
              修改密码<i class="el-icon-caret-bottom"></i>
            </div>
          </el-popover>
        </div>
        <div class="pointer logout" @click="logout">
          {{ language === "cn" ? "退出" : "Exit" }}
          <el-image
            class="ex-image"
            :src="exitIcon"
            style="width: 14px; height: 14px; margin-left: 3px"
          ></el-image>
          <el-image
            class="ex-image2"
            :src="exitIcon2"
            style="width: 14px; height: 14px; margin-left: 3px"
          ></el-image>
        </div>
      </div>
    </div>
    <el-dialog title="修改密码" :visible.sync="showResetDialog" width="50%">
      <el-form
        ref="resetForm"
        :model="resetForm"
        :rules="resetFormRules"
        label-width="90px"
        label-position="left"
      >
        <el-form-item label="">
          <div style="color: red">
            密码必须由大小写字母，数字以及特殊符号组成，并且不得小于8个字符！
          </div>
        </el-form-item>
        <el-form-item label="原密码：" prop="old_password">
          <el-input
            type="password"
            v-model="resetForm.old_password"
            placeholder="请输入原密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="new_password">
          <el-input
            type="password"
            v-model="resetForm.new_password"
            placeholder="请输入新密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="new_password_again">
          <el-input
            type="password"
            v-model="resetForm.new_password_again"
            placeholder="请再次输入新密码"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="verifyForm('resetForm')"
        >确认</el-button
      >
    </el-dialog>
  </div>
</template>
  
<script>
import { userLogout, resetPassword } from "@/api/api";
export default {
  data() {
    let validateNewPassword = (rule, value, callback) => {
      const passwordPattern =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]{8,}$/;
      if (value == "") {
        callback(new Error("请输入新密码！"));
      } else if (!passwordPattern.test(value)) {
        callback(
          new Error(
            "密码必须包含大写字母、小写字母、数字和特殊符号，并且至少8个字符！"
          )
        );
      } else {
        callback();
      }
    };
    let validateConfirmPassword = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请确认您的密码！"));
      } else if (value !== this.resetForm.new_password) {
        callback(new Error("请保证两次输入的密码是相同的！"));
      } else {
        callback();
      }
    };
    return {
      logo: require("../assets/fdi/fdi_logo.jpg"),
      logoWhite: require("../assets/logo_white.jpg"),
      exitIcon: require("../assets/exit_1.png"),
      exitIcon2: require("../assets/exit_2.png"),
      userInfor: {},
      menu_switch: "",
      language: "",
      showResetDialog: false,
      resetForm: {
        old_password: "",
        new_password: "",
        new_password_again: "",
      },
      resetFormRules: {
        old_password: [
          { required: true, message: "请输入原密码！", trigger: "blur" },
        ],
        new_password: [
          { required: true, validator: validateNewPassword, trigger: "blur" },
        ],
        new_password_again: [
          {
            required: true,
            validator: validateConfirmPassword,
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    this.menu_switch = sessionStorage.getItem("menu_switch");
    this.userInfor = userdata;
  },
  created() {
    this.language = localStorage.getItem("language");
  },
  methods: {
    // 是否有新站内信消息
    isNewMessage() {
      this.$alert("<strong>这是 <i>HTML</i> 片段</strong>", "紧急通知", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        center: true,
        confirmButtonText: "我已阅读并知晓",
        confirmButtonClass: "messagebtn",
      });
    },
    // 跳转到消息列表
    toMessage() {
      this.$router.push({
        path: "/messageList",
      });
    },
    logout() {
      let logoutLanguagetips = {};
      if (this.language === "cn") {
        logoutLanguagetips = {
          tips: "退出",
          content: "确定要退出吗？",
          confirm: "确定",
          cancel: "取消",
        };
      } else if (this.language === "en") {
        logoutLanguagetips = {
          tips: "Exit",
          content: "Are you sure you want to exit?",
          confirm: "confirm",
          cancel: "cancel",
        };
      }
      this.$confirm(logoutLanguagetips.content, logoutLanguagetips.tips, {
        confirmButtonText: logoutLanguagetips.confirm,
        cancelButtonText: logoutLanguagetips.cancel,
        type: "warning",
      })
        .then(() => {
          userLogout()
            .then((res) => {
              console.log(res, "======退出");
              if (res.data.code == 1) {
                let loginRes = {
                  token: null,
                  isLogin: false,
                };
                this.$store.commit("userStatus", loginRes);
                localStorage.clear();
                sessionStorage.removeItem("currentProductPage");
                // 状态保持清除后刷新页面
                window.location.reload();
                this.$router.push({
                  path: "/login",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    // 跳转到评奖
    tapdiscussion() {
      this.$router.push({
        name: "discussionindex",
      });
    },
    handleChooseLanguage(flag) {
      localStorage.setItem("language", flag);
      location.reload();
    },
    openResetDialog() {
      this.showResetDialog = true;
    },
    verifyForm(formName) {
      this.$refs[formName].validate((valid, field) => {
        if (valid) {
          let AA = this.resetForm.old_password == this.resetForm.new_password;
          let BB =
            this.resetForm.new_password_again == this.resetForm.new_password;
          if (AA) {
            return this.$message.warning("新密码不能与原密码一致！");
          } else if (!BB) {
            return this.$message.warning("新密码与确认密码不一致！");
          }
          this.submit();
        } else {
          let arr = Object.keys(field);
          this.$message.error(field[arr[0]][0].message);
          return false;
        }
      });
    },
    async submit() {
      let data = {
        password: this.resetForm.old_password,
        new_password: this.resetForm.new_password,
        confirm_password: this.resetForm.new_password_again,
      };
      const res = await resetPassword(data);
      if (res.data.code == "1") {
        this.$message.success("修改密码成功！");
        this.showResetDialog = false;
      } else {
        this.$message.error(res.data.msg);
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.username {
  cursor: pointer;
}
.el-popover {
  width: 50px !important;
  p {
    text-align: center;
    cursor: pointer;
    padding: 4px 0;
  }
  p:hover {
    background-color: rgba(0, 141, 255, 0.1);
    color: #008dff;
  }
}
.cypx {
  height: 30px;
  line-height: 30px;
  background: #fc9749;
  border-radius: 4px;
  border: 1px solid #fc9749;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
  margin-right: 10px;
}
.headertips {
  margin-right: 10px;
  font-size: 16px;
}
.headertips span:nth-child(1) {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
}
.headertips span:nth-child(2) {
}
.wcz {
  background: #c0c4cc;
}
.jxz {
  background: #faad14;
}
.wtg {
  background: red;
}
.ytg {
  background: #5de6dd;
}
.ywc {
  background: #1ac484;
}
.header {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px 0 30px;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 999;
  .logo {
    width: 100px;
    // height: 62px;
    // line-height: 62px;
    text-align: center;
  }
  .logo-white {
    display: none;
  }
  .header-title {
    font-size: 30px;
    font-weight: bold;
    color: #2c2c2e;
    margin: 0 40px 0 60px;
  }
  .language {
    margin-left: auto;
    margin-right: 16px;
    display: flex;
    align-items: center;
    span {
      font-size: 16px;
      color: #333;
      cursor: pointer;
    }
    span.active {
      font-weight: 700;
    }
    p {
      width: 1px;
      height: 12px;
      background-color: #333;
      margin: 0 8px;
    }
  }
  .right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-size: 14px;
    color: #2c2c2e;
    > div {
      padding: 0 20px;
    }
    .message {
      position: relative;
      .message-tips {
        position: absolute;
        top: -4px;
        right: 15px;
        width: 16px;
        height: 16px;
        color: #fff;
        font-size: 12px;
        line-height: 16px;
        border-radius: 50%;
        text-align: center;
        background: #ff4d4f;
      }
    }
    .border {
      border: 1px solid #848489;
      border-top: 0 none;
      border-bottom: 0 none;
      margin-right: 10px;
    }
    .pointer {
      cursor: pointer;
    }
    .logout {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 84px;
      height: 26px;
      padding: 0;
      background: #fff;
      transition: all 0.2s;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.06);
      border-radius: 5px;
      .ex-image2 {
        display: none;
      }
    }
    .logout:hover {
      color: #fff;
      background: #2c2c2e;
      text-decoration: underline;
      .ex-image {
        display: none;
      }
      .ex-image2 {
        display: block;
      }
    }
  }
}
.messagebtn {
  width: 146px;
  height: 40px;
  overflow: hidden;
  font-size: 16px;
  border: 0 none !important;
  background: #2c2c2e !important;
  border-radius: 5px;
}
.el-button {
  margin: 0 auto;
  display: block;
  padding: 12px 36px;
  margin-top: 40px;
}
.el-form-item {
  display: flex;
  justify-content: center;
  margin-bottom: 28px;
  .el-input {
    width: 300px;
  }

  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
  /deep/ .el-form-item__label {
    padding-right: 0 !important;
  }
}
@media (max-width: 1661px) {
  .header {
    padding: 0 20px;
  }
  .header-content {
    align-items: center;
    min-width: 740px !important;
    .header-title {
      font-size: 16px !important;
      margin: 0 20px 0 20px !important;
      min-width: 240px !important;
    }
    .cz {
      min-width: 500px;
      .headertips {
        span {
          font-size: 14px !important;
        }
      }
    }
  }
  .logo {
    min-width: 100px;
  }
  .language {
    margin-left: 0;
  }
  .right {
    font-size: 12px !important;
    .username,
    .border {
      text-align: center;
      width: 150px !important;
      padding-left: 8px !important;
      padding-right: 8px !important;
    }
    .username {
      text-align: right;
    }
    .border {
      text-align: left;
    }
  }
}
@media (max-width: 1024px) {
  .header-title {
    font-size: 20px !important;
    margin: 0 30px 0 34px !important;
  }
  .header .right > div {
    padding: 0px 9px;
  }
}
@media only screen and (max-width: 767px) {
  .header {
    height: 60px;
    padding: 0 18px 0 15px;
    background: #2c2c2e;
    justify-content: inherit;
    .header-title {
      display: none;
    }
    .cz {
      display: none;
    }
    .username {
      display: none;
    }
    .border {
      display: none;
    }
    .right {
      color: #fff;
      position: relative;
      justify-content: inherit;
      font-size: 12px !important;
      > div {
        padding: 0 6px;
      }
      .border {
        border-color: #fff;
      }
      .logout {
        color: #2c2c2e;
        position: absolute;
        right: 0;
      }
    }
    .logo {
      display: none;
    }
    .logo-white {
      width: 30px;
      margin-left: 0;
      // height: 30px;
      display: block;
    }
  }
  .header .right > div {
    margin-left: 10px;
  }
}
</style>
